module.exports = __webpack_public_path__ + "static/media/whichThinnerChoiceWarfarin.67d53841.mp3";